import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'newline'
})
export class NewlinePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
  
    // Ensure proper formatting for the text
    return value
      .replace(/^- (.+?):/gm, '<b> - $1:</b><br>') // Make lines starting with '-' bold and add a line break
      .replace(/:\s/g, ':<br>') // Add line break after colon followed by a space
      .replace(/(\.\s)(?!<br>)/g, '.<br>') // Add line breaks after periods only if not followed by a line break
      .replace(/\n/g, '<br>'); // Replace newlines with <br> for proper HTML rendering
  }
  
}
